import BraintreeLoader from '@/providers/braintree/BraintreeLoader';
import StripeLoader from '@/providers/stripe/StripeLoader';
import PaypalLoader from '@/providers/paypal/PaypalLoader';

function ProvidersLibsLoader() {
  return (
    <>
      <BraintreeLoader />
      <StripeLoader />
      <PaypalLoader />
    </>
  );
}

export default ProvidersLibsLoader;
